import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { useAccordion } from '../hooks/useAccordion';
import AccordionItem from './AccordionItem';
import { AccordionStyles } from './style';

const Accordion = ({ id, items, allowMultiple, variant, openItemIndex }) => {
  const { openItems, handleToggle, setOpenItemsManually, getOpenItems } = useAccordion(items, allowMultiple);
  const previousOpenItemIndex = useRef(null);

  useEffect(() => {
    if (openItemIndex !== null && openItemIndex !== undefined && openItemIndex !== previousOpenItemIndex.current) {
      const itemIndex = Number(openItemIndex);
      if (!Number.isNaN(itemIndex) && itemIndex >= 0 && itemIndex < items.length) {
        const currentOpenItems = getOpenItems();
        if (allowMultiple) {
          // Add to existing open items if not already open
          if (!currentOpenItems.includes(itemIndex)) {
            setOpenItemsManually([...currentOpenItems, itemIndex]);
          }
        } else {
          // Open only this item
          setOpenItemsManually([itemIndex]);
        }
        previousOpenItemIndex.current = openItemIndex;
      }
    }
  }, [openItemIndex, items.length, allowMultiple, getOpenItems, setOpenItemsManually]);

  return (
    <div className={`accordion accordion--${variant}`} id={id}>
      {items.map((item, index) => (
        <AccordionItem
          key={item.id || index}
          title={item.title}
          isOpen={openItems.includes(index)}
          onToggle={() => handleToggle(index)}
          variant={variant}
          alwaysOpen={item.alwaysOpen}
        >
          {item.content}
        </AccordionItem>
      ))}

      <style jsx>{AccordionStyles}</style>
    </div>
  );
};

Accordion.propTypes = {
  id: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      content: PropTypes.node.isRequired,
      alwaysOpen: PropTypes.bool,
      isOpen: PropTypes.bool,
    })
  ).isRequired,
  allowMultiple: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'product', 'filter']),
  openItemIndex: PropTypes.number,
};

Accordion.defaultProps = {
  id: '',
  allowMultiple: false,
  variant: 'default',
  openItemIndex: null,
};

export { Accordion };
export default Accordion;
